// extracted by mini-css-extract-plugin
export default {"layout-main":"HeaderLayout_layout-main__qtasQ","layout-conatiner":"HeaderLayout_layout-conatiner__dGtOy"};